module.exports = __webpack_public_path__ + "media/images/stock_groups/e87e-bcb064ce29ac75950923c9bc27233994.svg";